module.exports = __webpack_public_path__ + "img/events-icon.ee46daf7.svg";